export const spacing = {
  one: "0.25rem", // 4px
  two: "0.5rem", // 8px
  three: "1rem", // 16px
  four: "2rem", // 32px
  five: "4rem", // 64px
  six: "8rem" // 128px
};



// WEBPACK FOOTER //
// ./src/styles/spacing.js